import { Base_Url } from "../../Base Url/BaseUrl";
import { postApiWithAuthenticated, getListWithAuthenticated} from "../../Api Method/ApiMethod";


const BannerBaseUrl = `${Base_Url}/banner`;


export const bannerList = async (params) => {
  let url = `${BannerBaseUrl}/bannerList`;

  const res = await postApiWithAuthenticated(url, params);
  return res;
};

export const addUpdateBanner = async (url = '', params) => {
    
  
    const res = await postApiWithAuthenticated(`${BannerBaseUrl}${url}`, params);
    return res;
  };


export const ChangeBannerStatus = async (id) => {
  let url = `${BannerBaseUrl}/ChangeBannerStatus?BannerKeyID=${id}`;
  const res = await getListWithAuthenticated(url);
  return res;
};


export const getBanner = async (id) => {
    let url = `${BannerBaseUrl}/getBanner?BannerKeyID=${id}`;
  
    const res = await getListWithAuthenticated(url);
    return res;
  };
export const bannerListForWebsite = async (id) => {
    let url = `${BannerBaseUrl}/bannerListForWebsite`;
  
    const res = await getListWithAuthenticated(url);
    return res;
  };


